export const LINKS = {
  home: '/',
  about: '/about-us',
  faqs: '/faqs',
  blogs: '/blogs',
  contact: '/contact-us',
};
